import { createContext, ReactNode, useContext, useState } from "react"

export type StepStatesType = "warning" | "joyride" | "loading" | null
export type ImpactCourseTourElementType = "tab" | "card" | null
interface TourContextType {
  step: StepStatesType
  setStep: React.Dispatch<React.SetStateAction<StepStatesType>>
  stepIndex: number | undefined
  setStepIndex: React.Dispatch<React.SetStateAction<number | undefined>>
  tourElementType: ImpactCourseTourElementType
  setTourElementType: React.Dispatch<
    React.SetStateAction<"tab" | "card" | null>
  >
  // isLoading: boolean
  reset: () => void
}
const defaultValues: TourContextType = {
  step: null,
  setStep: () => {},
  stepIndex: undefined,
  setStepIndex: () => {},
  tourElementType: null,
  setTourElementType: () => {},
  reset: () => {},
}

export const TourContext = createContext<TourContextType>(defaultValues)

interface TourProviderProps {
  children: ReactNode
}

export const TourProvider = ({ children }: TourProviderProps) => {
  const [step, setStep] = useState<StepStatesType>(null)
  const [stepIndex, setStepIndex] = useState<number | undefined>()
  const [tourElementType, setTourElementType] =
    useState<ImpactCourseTourElementType>(null)
  const reset = () => {
    setStep(null)
    setStepIndex(undefined)
    setTourElementType(null)
  }
  return (
    <TourContext.Provider
      value={{
        step,
        setStep,
        stepIndex,
        setStepIndex,
        tourElementType,
        setTourElementType,
        reset,
      }}
    >
      {children}
    </TourContext.Provider>
  )
}
export const useTourContext = () => useContext(TourContext)
